/* eslint-disable jsx-a11y/iframe-has-title */
import React, { useEffect, useState } from 'react';
import RenewalTools from 'assets/images/campaign-renewal/renewal_tools.png';
import CheckSquareSolid from 'assets/images/campaign-renewal/check-square-solid.svg';
import CheckSolid from 'assets/images/campaign-renewal/check-solid.svg';
import IconBusiness from 'assets/images/campaign-renewal/renewal_business.png';
import IconProcess from 'assets/images/campaign-renewal/renewal_process.png';
import IconSupport from 'assets/images/campaign-renewal/renewal_support.png';
import RenewalTroph from 'assets/images/campaign-renewal/renewal_trophy.png';
import SupportConlicita from 'assets/images/campaign-renewal/renewal_conlicta_support.png';
import LogoBlack from 'assets/images/logo-conlicitacao-dark.png';
import IconInstagram from 'assets/images/campaign-renewal/renewal_instagram.png';
import IconWhatsapp from 'assets/images/campaign-renewal/renewal_whatsapp.png';
import IconMail from 'assets/images/campaign-renewal/renewal_mail.png';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { PackagesResponse, SimulateTypes } from 'store/modules/simulate_all_store/types';
import { ToggleButton, ToggleWrapper } from 'components/atoms/select_plans/styles';
import RenewalPlan from '../../components/atoms/renewal_plan';
import { ApplicationState } from '../../store';
import { PanelState } from '../../store/modules/panel_store/types';
import { Container } from './style';
import { getTheLastSale } from '../../services/actions/get_the_last_sale';
// import { SimulateTypes } from '../../store/modules/simulate_all_store/types';
import { MyAccountTypes } from '../../store/modules/my_account_store/types';
import Loader from '../../components/atoms/loader';

const CampaignRenewal = () => {
  const dispatch = useDispatch();
  const { panel } = useSelector<ApplicationState, PanelState>((state) => state.session.panel);
  const [viewPage, setViewPage] = useState<string>('inicio');
  const [plansData, setPlansData] = useState<PackagesResponse | null>(null);
  const [selectedPlan, setSelectedPlan] = useState<string>('');
  const [plans, setPlans] = useState<string[]>([]);

  useEffect(() => {
    const fetchData = async () => {
      document.title = 'Renovação online - ConLicitação';
      const data = await getTheLastSale();
      if (data) {
        setViewPage(data.layout);
        const planosTmp = Object.keys(data?.packages);
        if (planosTmp.length > 0) {
          const annualPlan = planosTmp.find((plan) => plan.toLowerCase() === 'anual');
          setSelectedPlan(annualPlan ?? planosTmp[0]);
          setPlans(planosTmp);
          setPlansData(data?.packages);
        }
      }

      dispatch({ type: SimulateTypes.STATE_CARD_PAYMENT, payment: data?.card_payment });

      setViewPage(data?.layout || data?.package_name);
    };

    fetchData();
  }, []);

  if (!panel?.renewal_campaign?.released_online) {
    return <Redirect to="/painel" />;
  }

  if (!panel?.validate_services?.course_iaml && panel?.registration_type_validation === 1) {
    return <Redirect to="/cadastrar" />;
  }

  if (viewPage === 'contact_screen') {
    return <Redirect to="/contato" />;
  }

  if (viewPage === 'all_packages') {
    setViewPage('');
  }

  if (viewPage === 'income_online') {
    dispatch({ type: MyAccountTypes.VIEW_COMPONENT, view: 'boletos_online' });
    window.location.href = '/minha_conta/boletos_online';
  }

  if (viewPage === 'inicio') {
    return (
      <div
        className="d-flex mx-auto justify-content-center align-items-center"
        style={{ height: '70vh' }}
      >
        <Loader />
      </div>
    );
  }

  if (!viewPage) {
    return <Redirect to="/contato" />;
  }

  if (!plansData) return false;

  return (
    <Container className="p-2">
      <div className="page-container">
        <div className="content-wrapper">
          <header>
            <div className="row">
              <div className="col-md div_logo" />
              <div className="col-md div_logo_sider">
                <div className="div_logo_interna">
                  Ganhe tempo e venda para o governo com mais segurança
                </div>
              </div>
            </div>
          </header>
          <section className="pt-5 font_17">
            <div className="row">
              <div className="col-md">
                <p>
                  Olá, <strong>{panel?.renewal_campaign?.contact_name}</strong>
                </p>
                <p>
                  Agradecemos a sua escolha pelo ConLicitação e desejamos continuar com nossa
                  parceria.{' '}
                </p>
                <p>
                  Apresentamos aqui a <strong>melhor oferta</strong> para você realizar a renovação
                  da sua assinatura.
                </p>
              </div>
              <div className="col-md-4">
                <img src={RenewalTools} alt="Renewal Tools" style={{ width: '200px' }} />
              </div>
            </div>

            <hr className="hr_renewal" />
            <div className="row mb-5">
              <div className="col-md-12 text-center font_25">
                Veja os benefícios que você só encontra no ConLicitação
              </div>
            </div>

            <div className="row">
              <div className="col-md-12 beneficios">
                <img src={CheckSquareSolid} alt="Check Square" width="24px" className="mr-2" />
                Equipe interna de advogados dedicada para prestar consultoria jurídica e consultoria
                técnica
              </div>
              <div className="col-md-12 beneficios">
                <img src={CheckSquareSolid} alt="Check Square" width="24px" className="mr-2" />
                Encontre licitações regionais que não são divulgadas nos grandes portais de
                licitação
              </div>
              <div className="col-md-12 beneficios">
                <img src={CheckSquareSolid} alt="Check Square" width="24px" className="mr-2" />
                Acompanhe as licitações que a sua empresa está participando até o resultado final
              </div>
              <div className="col-md-12 beneficios">
                <img src={CheckSquareSolid} alt="Check Square" width="24px" className="mr-2" />
                Atualize automaticamente os principais documentos para participar de licitações
              </div>
              <div className="col-md-12 beneficios">
                <img src={CheckSquareSolid} alt="Check Square" width="24px" className="mr-2" />
                Monitoramos diariamente mais de 45 portais de disputas e 6 mil fontes oficiais
              </div>
              <div className="col-md-12 beneficios">
                <img src={CheckSquareSolid} alt="Check Square" width="24px" className="mr-2" />
                Cursos exclusivos gravados em nossos estúdios com qualidade de cinema
              </div>
            </div>

            <hr className="hr_renewal" />
            <div className="row mb-5">
              <div className="col-md-12 text-center font_25">
                Mais de 20 serviços do ConLicitação disponíveis na sua assinatura
              </div>
            </div>

            <div className="row">
              <div className="col-md info_servicos">
                <div className="row ml-4 mb-3 d-flex align-items-center">
                  <div>
                    <img src={IconBusiness} alt="Icon Business" width="50px" className="mb-3" />
                  </div>
                  <div className="font_18 text-center px-3">
                    Oportunidade de <br />
                    Negócios
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-1">
                    <img src={CheckSolid} alt="Check Solid" height="21px" />
                  </div>
                  <div className="col-md">
                    <p>Encontre as melhores licitações</p>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-1">
                    <img src={CheckSolid} alt="Check Solid" height="21px" className="mr-2" />
                  </div>
                  <div className="col-md">
                    <p>Boletins diários de licitação</p>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-1">
                    <img src={CheckSolid} alt="Check Solid" height="21px" className="mr-2" />
                  </div>
                  <div className="col-md">
                    <p>Análise de Mercado e de Concorrentes</p>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-1">
                    <img src={CheckSolid} alt="Check Solid" height="21px" className="mr-2" />
                  </div>
                  <div className="col-md">
                    <p>Busque por Contratos e Atas de Registro de Preços</p>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-1">
                    <img src={CheckSolid} alt="Check Solid" height="21px" className="mr-2" />
                  </div>
                  <div className="col-md">
                    <p>Licitações desertas e de baixa concorrência</p>
                  </div>
                </div>
              </div>

              <div className="col-md info_servicos">
                <div className="row ml-4 mb-3 d-flex align-items-center">
                  <div>
                    <img src={IconProcess} alt="Icon Business" width="50px" className="mb-3" />
                  </div>
                  <div className="font_18 text-center px-3">
                    Gestão das <br />
                    Licitações
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-1">
                    <img src={CheckSolid} alt="Check Solid" height="21px" className="mr-2" />
                  </div>
                  <div className="col-md">
                    <p>Gerencie as licitações que você está participando</p>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-1">
                    <img src={CheckSolid} alt="Check Solid" height="21px" className="mr-2" />
                  </div>
                  <div className="col-md">
                    <p>Otimize as operações da sua equipe de vendas</p>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-1">
                    <img src={CheckSolid} alt="Check Solid" height="21px" className="mr-2" />
                  </div>
                  <div className="col-md">
                    <p>Encontre acompanhamentos e o seu histórico nas licitações</p>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-1">
                    <img src={CheckSolid} alt="Check Solid" height="21px" className="mr-2" />
                  </div>
                  <div className="col-md">
                    <p>Monitore mensagens recebidas nos chats do pregoeiro</p>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-1">
                    <img src={CheckSolid} alt="Check Solid" height="21px" className="mr-2" />
                  </div>
                  <div className="col-md">
                    <p>Atualize automaticamente os seus principais documentos</p>
                  </div>
                </div>
              </div>

              <div className="col-md info_servicos">
                <div className="row ml-4 mb-3 d-flex align-items-center">
                  <div>
                    <img src={IconSupport} alt="Icon Business" width="50px" className="mb-3" />
                  </div>
                  <div className="font_18 text-center px-3">
                    Consultoria e <br />
                    Treinamento
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-1">
                    <img src={CheckSolid} alt="Check Solid" height="21px" className="mr-2" />
                  </div>
                  <div className="col-md">
                    <p>Suporte ilimitado e consultoria jurídica de alta qualidade</p>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-1">
                    <img src={CheckSolid} alt="Check Solid" height="21px" className="mr-2" />
                  </div>
                  <div className="col-md">
                    <p>Esclarecimento de dúvidas e Portal Jurídico Fácil</p>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-1">
                    <img src={CheckSolid} alt="Check Solid" height="21px" className="mr-2" />
                  </div>
                  <div className="col-md">
                    <p>Mais de 100 cursos para você assistir quando e onde quiser</p>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-1">
                    <img src={CheckSolid} alt="Check Solid" height="21px" className="mr-2" />
                  </div>
                  <div className="col-md">
                    <p>Cursos exclusivos e certificado com validade nacional</p>
                  </div>
                </div>
              </div>
            </div>

            <hr className="hr_renewal" />
            <div className="row">
              <div className="col-md-12 mb-5 text-center font_25">
                Conheça abaixo a condição especial para renovar sua assinatura
              </div>
            </div>
            <div className="row">
              <div className="col font_30 d-flex align-items-center ml-4">
                <p>Ganhe 10% de desconto e parcelamento sem juros no cartão de crédito</p>
              </div>
              <div className="col-md-6 d-flex align-items-center">
                <img src={RenewalTroph} alt="Renewal Troph" width="400px" />
              </div>
            </div>

            <hr className="hr_renewal" />
            <div className="row mb-5">
              <div className="col-md-12 text-center font_25">
                Selecione a vigência mais adequada para a sua nova assinatura
              </div>
            </div>
            <div className="d-flex justify-content-center mb-4">
              <ToggleWrapper>
                {plans &&
                  plans.map((plano) => (
                    <ToggleButton
                      key={plano}
                      active={selectedPlan === plano}
                      onClick={() => setSelectedPlan(plano)}
                    >
                      {plano}
                    </ToggleButton>
                  ))}
              </ToggleWrapper>
            </div>
            <div className="row px-3 justify-content-center">
              {plansData[selectedPlan] &&
                Object.entries(plansData[selectedPlan]).map(([pacote, formasPagamento]) => (
                  <RenewalPlan
                    key={plansData[selectedPlan] + pacote}
                    plan={selectedPlan}
                    packageName={pacote}
                    prices={formasPagamento.card}
                  />
                ))}
            </div>

            <hr className="hr_renewal" />
            <div className="row">
              <div className="col-md font_16">
                <p>
                  O maior banco de dados de licitação do país você encontra aqui no ConLicitação.
                </p>
                <p>Estamos comprometidos em oferecer constantemente melhorias e inovações.</p>
                <p>Acesse as licitações na plataforma web e também no nosso aplicativo celular.</p>
                <p>Fique à vontade para nos contactar se tiver algumar dúvida.</p>
                <p className="bold">Agradecemos por confiar em nossa empresa!</p>
              </div>
              <div className="col-md-3 center-image">
                <img src={SupportConlicita} alt="Support Conlicita" width="172" />
              </div>
              <div className="col-md-1" />
            </div>

            <hr className="hr_renewal" />
            <div className="row font_14">
              <div className="col-md-12 text-center mb-3">
                <img src={LogoBlack} alt="Logo ConLicitação" width="160px" />
              </div>
              <div className="col-md-12 text-center mb-3">
                <div className="row">
                  <div className="col-md" />
                  <div className="col-md-2">
                    <img
                      src={IconInstagram}
                      alt="Instagram ConLicitação"
                      width="33px"
                      className="mr-2"
                    />
                    <img
                      src={IconWhatsapp}
                      alt="Whatsapp ConLicitação"
                      width="33px"
                      className="mr-2"
                    />
                    <img src={IconMail} alt="Email ConLicitação" width="33px" />
                  </div>

                  <div className="col-md" />
                </div>
              </div>
              <div className="col-md-12 text-center mb-3">
                Consórcio Nacional de Licitação HQZ LTDA - 03.635.879/0001-36
              </div>
              <div className="col-md-12 text-center mb-3">
                Política de Privacidade | Termos e Condições
              </div>
              <div className="col-md-12 text-center mb-3">© Todos os direitos reservados.</div>
            </div>
          </section>
        </div>
      </div>
    </Container>
  );
};

export default CampaignRenewal;
